const DEFAULT_BRAND_COLOR = "#000a60";

export function getBrandPrimaryColor() {
  if (typeof window === "undefined") {
    return DEFAULT_BRAND_COLOR;
  }
  const styles = getComputedStyle(document.documentElement);
  return (
    styles.getPropertyValue("--branding-theme-color").trim() ||
    styles.getPropertyValue("--theme-color").trim() ||
    styles.getPropertyValue("--skin1").trim() ||
    DEFAULT_BRAND_COLOR
  );
}

export function brandColorWithAlpha(alpha) {
  const color = getBrandPrimaryColor();
  const normalized = String(color || "").trim();
  if (!normalized) {
    return `rgba(0, 10, 96, ${alpha})`;
  }
  if (normalized.startsWith("#")) {
    let hex = normalized.slice(1);
    if (hex.length === 3) {
      hex = hex.split("").map(char => char + char).join("");
    }
    if (hex.length === 6) {
      const int = parseInt(hex, 16);
      const r = (int >> 16) & 255;
      const g = (int >> 8) & 255;
      const b = int & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
  if (normalized.startsWith("rgba(")) {
    const values = normalized.slice(5, -1).split(",").map(part => part.trim());
    if (values.length >= 3) {
      return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${alpha})`;
    }
  }
  if (normalized.startsWith("rgb(")) {
    return normalized.replace("rgb(", "rgba(").replace(")", `, ${alpha})`);
  }
  return normalized;
}

/** Chart segment fills derived from tenant branding (e.g. doughnut slices). */
export function getBrandingChartPalette(segmentCount = 3) {
  const steps = [1, 0.72, 0.44, 0.28];
  return Array.from({ length: Math.max(segmentCount, 1) }, (_, index) =>
    brandColorWithAlpha(steps[index] ?? 0.2),
  );
}
